var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{},_vm._l((_vm.tags),function(tag,index){return _c('router-link',{key:tag,class:['hashtag', 'text-secondary', {'ps-1': index !== 0}],attrs:{"to":"#"}},[_vm._v(_vm._s(_vm.formatTag(tag)))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }